import instance from '@/api/business' 
import { Employee } from '@/types/Employee' 

const BASE_URL = '/resale/im/Employee'

export const fetchEmployee = async (SK_REVENDA: number) => {
    const response = await instance.post<Employee[]>(BASE_URL, {
        SK_REVENDA: SK_REVENDA
    })

    return response.data
}

export const updateEmployeeResearchStatus = async (
    SK_FUNCIONARIO: string,
    DD_PARTICIPA_PESQUISA: number
) => {
    const response = await instance.post<{ status: number; message: string }>(
        '/resale/im/employee/research-status',
        {
            SK_FUNCIONARIO,
            DD_PARTICIPA_PESQUISA,
        }
    )

    return response.data
}